// removed by extract-text-webpack-plugin
module.exports = {"mainDiv":"_3p1UNKV6pCPAMXOSw-9YkJ","mainImg":"dMmzMuI1EYLckkqTlKtIT","title":"_3xe4HBBHrGetfY05MTZLlj","subtitle":"_3lBQWSqIwvM2kJAZ5sJ1Or","text":"_12t-aA4qYMJpaXe_9JDj07","spacer":"_1lWX5O1Vdnmv_CUyjJD-l4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/AboutMe/AboutMe.css
// module id = 30
// module chunks = 0